import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { login, passwordless } from '../modules/auth'
import { reduxForm } from 'redux-form'

import component from 'components/Login'

const mapActionCreators = {
  onSubmit: login,
  passwordless
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state, ownProps) => {
  let obj = {
    user: state.auth && state.auth.user,
    message: state.auth && state.auth.message,
    initialValues: {
      email: ownProps.params.email || ownProps.location.query.email || undefined,
      magic_token: ownProps.params.magic_token || ownProps.location.query.magic_token || undefined
    }
  }

  return obj
}

const form = reduxForm({
  form: 'login',
  fields: ['email', 'password', 'magic_token'],
  touchOnChange: true,
  validate (state) {
    var errors = {}

    if (!state.magic_token) {
      if (!state.password) {
        errors.password = 'Please enter your password.'
      } else if (state.password.length < 6) {
        errors.password = 'Your password must be at least 6 characters long.'
      }
    }

    if (!state.email) {
      errors.email = 'Please enter your email address.'
    } else if (state.email.length < 6 || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
      errors.email = 'Please enter a valid email address.'
    }

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Auth/containers/LoginContainer.js